function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 37.79,
  cy: 37.729,
  r: 10.5,
  fill: "#23C386"
});

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 37.312,
  cy: 37.229,
  stroke: "#00C791",
  rx: 37.312,
  ry: 37.229
});

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 46.64,
  cy: 46.536,
  stroke: "#00C791",
  rx: 46.64,
  ry: 46.536
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 55.968,
  cy: 55.843,
  stroke: "#00C791",
  rx: 55.968,
  ry: 55.843
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 65.296,
  cy: 65.151,
  stroke: "#00C791",
  rx: 65.296,
  ry: 65.151
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 74.624,
  cy: 74.458,
  stroke: "#00C791",
  rx: 74.624,
  ry: 74.458
});

var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 83.952,
  cy: 83.765,
  stroke: "#00C791",
  rx: 83.952,
  ry: 83.765
});

var _ref8 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 93.28,
  cy: 93.072,
  stroke: "#00C791",
  rx: 93.28,
  ry: 93.072
});

var _ref9 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 37.542,
  cy: 37.978,
  fill: "#742097",
  rx: 10.523,
  ry: 10.5
});

var _ref10 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 37.312,
  cy: 37.229,
  stroke: "#742097",
  rx: 37.312,
  ry: 37.229
});

var _ref11 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 46.64,
  cy: 46.536,
  stroke: "#742097",
  rx: 46.64,
  ry: 46.536
});

var _ref12 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 55.968,
  cy: 55.843,
  stroke: "#742097",
  rx: 55.968,
  ry: 55.843
});

var _ref13 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 65.296,
  cy: 65.151,
  stroke: "#742097",
  rx: 65.296,
  ry: 65.151
});

var _ref14 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 74.624,
  cy: 74.458,
  stroke: "#742097",
  rx: 74.624,
  ry: 74.458
});

var _ref15 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 83.952,
  cy: 83.765,
  stroke: "#742097",
  rx: 83.952,
  ry: 83.765
});

var _ref16 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 93.28,
  cy: 93.072,
  stroke: "#742097",
  rx: 93.28,
  ry: 93.072
});

function SvgChaosEngineeringToday(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 349 326"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    transform: "rotate(47 -27.912 251.425)"
  }, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    transform: "rotate(165 93.604 93.497)"
  }, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(62 223.433 215.951)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 131.957,
    cy: 210.637,
    r: 10.5,
    fill: "#205C9D",
    style: {
      mixBlendMode: "screen"
    },
    transform: "rotate(-135 131.957 210.637)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.457,
    cy: 211.137,
    r: 37.27,
    stroke: "#205C9D",
    style: {
      mixBlendMode: "screen"
    },
    transform: "rotate(-135 132.457 211.137)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.457,
    cy: 197.975,
    r: 46.588,
    stroke: "#205C9D",
    style: {
      mixBlendMode: "screen"
    },
    transform: "rotate(-135 132.457 197.975)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.457,
    cy: 184.812,
    r: 55.906,
    stroke: "#205C9D",
    style: {
      mixBlendMode: "screen"
    },
    transform: "rotate(-135 132.457 184.812)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.457,
    cy: 171.65,
    r: 65.223,
    stroke: "#205C9D",
    style: {
      mixBlendMode: "screen"
    },
    transform: "rotate(-135 132.457 171.65)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.457,
    cy: 158.488,
    r: 74.541,
    stroke: "#205C9D",
    style: {
      mixBlendMode: "screen"
    },
    transform: "rotate(-135 132.457 158.488)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.457,
    cy: 145.325,
    r: 83.858,
    stroke: "#205C9D",
    style: {
      mixBlendMode: "screen"
    },
    transform: "rotate(-135 132.457 145.325)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.457,
    cy: 132.163,
    r: 93.176,
    stroke: "#205C9D",
    style: {
      mixBlendMode: "screen"
    },
    transform: "rotate(-135 132.457 132.163)"
  }))));
}

export default "data:image/svg+xml;base64,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";
export { SvgChaosEngineeringToday as ReactComponent };